import { createSelector } from '@reduxjs/toolkit';

import { MOSCOW_REGION_ID, SPB_REGION_ID } from '@/microfrontends/filters/shared/constants/regions';
import { normalizeLocationId } from '@/microfrontends/filters/shared/utils/location/normalizeLocationId';

import { locationSelector } from './root';

/**
 * @deprecated лучше использовать selectCurrentLocationIdSafe
 * @warning Использовать осторожно, возвращает синтетические locationId
 * @returns -1 для Москвы, -2 для Санкт-Петербурга, иначе locationId
 */
export const selectCurrentLocationId = createSelector(locationSelector, ({ data: location }): -1 | -2 | number => {
  return normalizeLocationId(location);
});

export const selectCurrentLocationIdSafe = createSelector(selectCurrentLocationId, (locationId): number => {
  if (locationId === -1) {
    return MOSCOW_REGION_ID;
  }

  if (locationId === -2) {
    return SPB_REGION_ID;
  }

  return locationId;
});
